import React from 'react';
import Icon from '../../../components/AppIcon';

const EmptyDependentsState = ({ onAddDependent }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center mb-6">
        <Icon name="Users" size={40} className="text-primary" strokeWidth={2} />
      </div>
      
      <h3 className="text-xl sm:text-2xl font-heading font-semibold text-foreground mb-3 text-center">
        No Dependent Users Yet
      </h3>
      
      <p className="text-sm sm:text-base text-muted-foreground text-center max-w-md mb-6">
        Start managing health tracking for your dependents by adding their profiles. You can track symptoms, view activity summaries, and manage permissions.
      </p>
      
      <button
        onClick={onAddDependent}
        className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-primary-foreground rounded-lg font-medium transition-smooth hover:bg-primary/90 focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background active:scale-[0.97]"
      >
        <Icon name="UserPlus" size={20} strokeWidth={2} />
        Add Dependent User
      </button>
    </div>
  );
};

export default EmptyDependentsState;